// @ts-strict-ignore
export const lineOptions = (points) => ({
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    point: {
      backgroundColor: '#DB4D75',
      radius: (ctx: any) => (points.includes(ctx.parsed?.x) ? 8 : 3),
    },
  },
  scales: {
    y: {
      position: 'right',
      color: '#ADAFB3',
      beginAtZero: true,
      ticks: {
        callback: (val: number) => (val % 1000 === 0 ? `£${val / 1000}K` : `£${val}`),
      },
      min: 0,
      grid: {
        borderColor: '#ADAFB3',
      },
    },
    x: {
      grid: {
        borderColor: '#ADAFB3',
      },
      min: 0,
      max: 100,
      ticks: {
        maxRotation: 20,
        autoSkip: true,
        includeBounds: true,
      },
    },
  },
  plugins: {
    legend: {
      onClick: () => {},
      position: 'bottom' as const,
      display: true,
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
        font: {
          size: 14,
        },
      },
    },
    title: {
      display: true,
      text: 'PENSION POT',
      color: '#6D6F73',
      font: {
        size: 14,
      },
    },
  },
})
